const DownloadButtons = ({text}) => {

    
    return(
        <>
            <div>
                <button className="download_btn">{text}</button>
            </div>
        </>
    )
}

export default DownloadButtons;